/* global BigInt */
/** A dollar amount the way it is read: $1,234.50. Nothing to show reads as an em dash. */
export const money = (n) =>
  n == null || Number.isNaN(Number(n))
    ? '—'
    : `$${Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

/** Saved integer cents must keep their final cent even near the safe-integer limit. */
export const moneyMinor = (cents) =>
  !Number.isSafeInteger(cents) || cents < 0
    ? null
    : `$${(BigInt(cents) / 100n).toLocaleString('en-US')}.${String(cents % 100).padStart(2, '0')}`;
